<template>
  <PieChart
    :request-status="requestStatus"
    :series="series"
    :title="title"
    :item-id="itemId"
    is-polarity
    class="make-a-copy"
    v-bind="$attrs"
    :field-label="fields[0]"
    @reload="getData"
  />
</template>

<script>
import PieChart from '@/components/cards/models/PieChart';
import { mapActions } from 'vuex';
import EventBus from '@/utils/event-bus';
import { DATE_PORTION, POINTS_PARSER } from '@/services/charts-service';

export default {
  name: 'ComponentBuilderPieChart',
  components: {
    PieChart,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    fields: {
      type: Array,
      default: () => [],
    },
    operation: {
      type: String,
      default: null,
    },
    entity: {
      type: String,
      default: null,
    },
    grouping: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      rawSeries: [],
      axesSeriesName: [],
    };
  },
  computed: {
    series() {
      if (this.rawSeries) {
        const formatted = this.rawSeries.map(serie => {
          return {
            name: serie.x,
            y: serie.z || 0,
          };
        }).sort((current, previous) => {
          if (current.y < previous.y) {
            return 1;
          }
          return current.y > previous.y ? -1 : 0;
        });
        return formatted;
      }
      return [];
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getChartsService',
    ]),
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      this.getChartsService({
        itemId: this.itemId,
        method: 'getTimeSeries',
        entity: this.entity,
        points_parser: POINTS_PARSER.POINTS,
        params: {
          fields: this.fields,
          datePortion: DATE_PORTION.BY_YEAR,
          grouping: this.grouping,
          operators: this.operation,
        },
      })
        .then(response => {
          this.rawSeries = response.points;

          this.requestStatus = 'success';

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch(error => {
          console.error(error);
          this.requestStatus = 'error';
        });
    },
  },
};
</script>
